import { reactive } from "vue";
import en_US from "@/data/en-US.json";
import pt_PT from "@/data/pt-PT.json";

const store = {
  state: reactive({
    language: null,
  }),
  getters: {
    getLanguage() {
      return store.state.language;
    },
  },
  mutations: {
    changeLanguage(id) {
      switch (id) {
        case "en-US":
          store.state.language = en_US;
          break;
        case "pt-PT":
          store.state.language = pt_PT;
          break;
        default:
          store.state.language = pt_PT;
          break;
      }
    },
  },
  actions: {
    initializeLanguage() {
      store.mutations.changeLanguage(navigator.language);
    },
  },
};

export default store;
